import { createEntityAdapter } from '@reduxjs/toolkit';

import { IFeedItem } from '@wix/social-groups-serverless/dist/feed/types';

export const adapter = createEntityAdapter<IFeedItem>({
  selectId: (item) => item.feedItemId as string,
});
